const Switch = ({ checked, onChange, label }) => {
    return (
        <label className="flex items-center cursor-pointer select-none">
            <div className="relative">
                <input
                    title="Active/InActive form toggle"
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    className="sr-only"
                />
                <div
                    className={`w-10 h-6 rounded-full transition-colors duration-300 ${checked ? "bg-blue-600" : "bg-gray-300"}`}
                ></div>
                <div
                    className={`absolute left-1 top-1 w-4 h-4 rounded-full bg-white shadow-md transform transition-transform duration-300 ${checked ? "translate-x-4" : ""}`}
                ></div>
            </div>
            {label && (
                <span className={`ml-3 text-sm font-medium ${checked ? "text-blue-600" : "text-gray-500"}`}>{label}</span>
            )}
        </label>
    );
};

export default Switch; 